export default {
    maintenancewarningevent_main_title: 'Advertencias de Mantenimiento',
    maintenancewarningevent_main_esn: 'Serial',
    maintenancewarningevent_main_label: 'Nombre',
    maintenancewarningevent_main_linkedMode: 'Modo',
    maintenancewarningevent_main_linkedUnitLabel: 'Unidad emparejada',
    maintenancewarningevent_main_unitTime: 'Fecha de la Unidad',
    maintenancewarningevent_main_warning: 'Advertencia',
    maintenancewarningevent_main_value: 'Valor',
    maintenancewarningevent_main_no_data: 'No hay datos disponibles',
    maintenancewarningevent_main_details: 'Detalles',
    maintenancewarningevent_main_company: 'Compañia',
}